/* @refresh reload */
import { render } from 'solid-js/web';
import { installAppUpdates } from './appUpdate.ts';
import { App } from './App.tsx';
import { SignInGate } from './components/SignInGate.tsx';
import { installErrorCapture } from './diag/errors.ts';

// First, so an error thrown while the app boots is recorded too. Survives a
// restart, so a freeze cured by restarting still leaves its cause on disk.
installErrorCapture();

// No-op in dev (vite-plugin-pwa's devOptions.enabled defaults to false, so
// this virtual module resolves to a stub there) — real only in a production
// build, which is what makes the hosted subdomain able to boot offline.
// Updates wait while the suite is performing (appUpdate.ts, 2026-09-30).
installAppUpdates();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

render(() => (
  <SignInGate>
    <App />
  </SignInGate>
), root);
